export default "__VITE_ASSET__Bykh0HQx__"